import classNames from 'classnames';
import Decimal from 'decimal.js';
import { useEffect, useState } from 'react';

import { implog } from '@/api/implog';
import icon_checked from '@/assets/icon/icon_checked.webp';
// import topBg from '@/assets/modal/jieti_bg.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import useRecharge from '@/hooks/useRecharge';
import { modalStore } from '@/stores/modal';

import styles from './styles.module.less';

const JietiModal = () => {
  const { jietiConfigs } = modalStore;
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    implog('jieti_modal_show');
  }, []);

  useEffect(() => {
    if (jietiConfigs.length > 0) {
      setAmount(jietiConfigs[0].payfee);
    }
  }, [jietiConfigs]);

  const { runRecharge } = useRecharge();
  return (
    <div className={styles.container}>
      <BlurryLoadingImage
        loading="lazy"
        src={`${window?.imgPrefix || ''}/img/modal/jieti_bg.webp`}
        className={styles.bg}
      />
      <div className={styles.head}>Exclusive offers for you</div>
      <div className={styles.main}>
        <div className={styles.thead}>
          <div>Deposit</div>
          <div>Bonus</div>
          <div>Total Received</div>
        </div>

        {jietiConfigs?.map(({ rid, rate, payfee, sendamount }) => (
          <div
            key={rid}
            className={classNames(styles.tbody_tr, { [styles.active_tr]: payfee === amount })}
            onClick={() => {
              setAmount(payfee);
            }}
          >
            <div>$ {payfee}</div>
            <div style={{ whiteSpace: 'nowrap' }}>+{rate}%</div>
            <div className={styles.last_child}>{Decimal.add(payfee, sendamount).toNumber()}</div>
            <div className={styles.checked}>
              <BlurryLoadingImage loading="lazy" src={icon_checked} alt="" />
            </div>
          </div>
        ))}
        <Button
          block
          size="large"
          type="success"
          style={{ marginTop: '0.5rem' }}
          onClick={() => {
            implog('jieti_modal_click', amount.toString());

            runRecharge({
              amount,
              cztype: 'jieti'
            });
          }}
        >
          Deposit ${amount}
        </Button>
      </div>
      <div className={styles.tips}>Deposit any amount and get a bonus $0.5-1</div>
    </div>
  );
};

export default JietiModal;
